module.exports = __webpack_public_path__ + "static/img/4.d50854f.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/4/4.png
// module id = 243
// module chunks = 0